import React from "react";
import {Box, Stack, Typography, TextField} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

const ExpenseTypesForm = ({handleChangeName, handleChangeDescription}) => {
  return (
          <Grid container spacing={4}>
            <Grid xs={12} sm={12}>
                <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.12)", borderRadius: "4px", padding: "1rem" }}>
                  <Grid container spacing={2} marginTop={"10px"}>
                    <Grid xs={12} sm={12}>
                      <Stack spacing={2}>
                        <Typography variant="h6" component="div">
                            Enter the Name of the Expense Type
                        </Typography>
                        <TextField
                            required
                            id="outlined-required"
                            label="Expense Type Name"
                            onChange={handleChangeName}
                            fullWidth={true}
                            variant="outlined"
                            margin="dense"
                            autoFocus
                        />
                      </Stack>
                    </Grid>
                    <Grid xs={12} sm={12}>
                      <Stack spacing={2}>
                        <Typography variant="h6" component="div">
                            Enter the Description of the Expense Type
                        </Typography>
                        <TextField
                            id="outlined-required"
                            label="Expense Type Description"
                            onChange={handleChangeDescription}
                            fullWidth={true}
                            variant="outlined"
                            margin="dense"
                            autoFocus
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
            </Grid>
          </Grid>
   );
};

export default ExpenseTypesForm;